var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g(_vm._b({class:['carousel-page-button', _vm.label, {
		'hide-mobile': _vm.hideMobile,
		'hide-tablet': _vm.hideTablet
	}],attrs:{"aria-label":`${_vm.label} slides`}},'button',_vm.$attrs,false),_vm.$listeners),[_c('icon',{attrs:{"name":_vm.iconName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }